import { combineReducers } from 'redux';
import { sessionReducer as session } from 'redux-react-session';
import { configureStore } from '@reduxjs/toolkit'
// Middleware
import errorMiddleware from '../middlewares/error';
// App
import app from './app';
// Appointment Flows
import appointmentFlows from './appointmentFlows';
// Appointment Analyses
import appointmentAnalyses from './appointmentAnalyses';
//Blobs
import blobs from './blobs';
// Book Flows
import bookFlows from './bookFlows';
// Book Analyses
import bookAnalyses from './bookAnalyses';
// Confirm Flows
import confirmFlows from './confirmFlows';
// Confirm Analyses
import confirmAnalyses from './confirmAnalyses';
// Confirmations
import confirmations from './confirmations';
// Conversations
import conversations from './conversations';
// Waterfall Analyses
import waterfallAnalyses from './waterfallAnalyses';
// Waterfall Flows
import waterfallFlows from './waterfallFlows';
// Error
import error from './error';
// Esign Flows
import esignFlows from './esignFlows';
// Esign Analyses
import esignAnalyses from './esignAnalyses';
// Esign Templates
import esignTemplates from './esignTemplates';
//Events
import events from './events';
// Fifth Flows
import fifthFlows from './fifthFlows';
// Fifth Analyses
import fifthAnalyses from './fifthAnalyses';
// Fill Flows
import fillFlows from './fillFlows';
// Fill Analyses
import fillAnalyses from './fillAnalyses';
// Fill Templates
import fillTemplates from './fillTemplates';
// First Flows
import firstFlows from './firstFlows';
// First Analyses
import firstAnalyses from './firstAnalyses';
// Invitations
import invitations from './invitations';
// Locations
import locations from './locations';
// Managers
import managers from './managers';
// Messages
import messages from './messages';
// Nylas
import nylas from './nylas';
// Patient Flows
import patientFlows from './patientFlows';
// Patient Analyses
import patientAnalyses from './patientAnalyses';
// Patients
import patients from './patients';
// Pen Study Flows
import penStudyFlows from './penStudyFlows';
// Pen Study Analyses
import penStudyAnalyses from './penStudyAnalyses';
// Profile
import profile from './profile';
// Referral Flows
import referralFlows from './referralFlows';
// Referral Analyses
import referralAnalyses from './referralAnalyses';
// Reminder Flows
import reminderFlows from './reminderFlows';
// Reminder Analyses
import reminderAnalyses from './reminderAnalyses';
// Schedule Flows
import scheduleFlows from './scheduleFlows';
// Schedule Analyses
import scheduleAnalyses from './scheduleAnalyses';
// Clinicians
import clinicians from './clinicians';
// Second Flows
import secondFlows from './secondFlows';
// Second Analyses
import secondAnalyses from './secondAnalyses';
// Sessions
import sessions from './sessions';
// Seventh Flows
import seventhFlows from './seventhFlows';
// Seventh Analyses
import seventhAnalyses from './seventhAnalyses';
// Sixth Flows
import sixthFlows from './sixthFlows';
// Sixth Analyses
import sixthAnalyses from './sixthAnalyses';
// Study Flows
import studyFlows from './studyFlows';
// Study Analyses
import studyAnalyses from './studyAnalyses';
// Study Tasks
import studyTasks from './studyTasks';
// Success
import success from './success';
// Superbill Analyses
import superbillAnalyses from './superbillAnalyses';
// Superbill Flows
import superbillFlows from './superbillFlows';
// Superbill Goals
import superbillGoals from './superbillGoals';
// Superbill Tasks
import superbillTasks from './superbillTasks';
// Templates
import templates from './templates';
// Third Analyses
import thirdAnalyses from './thirdAnalyses';
// Third Flows
import thirdFlows from './thirdFlows';
// Voice Flows
import voiceFlows from './voiceFlows';
// Voice Analyses
import voiceAnalyses from './voiceAnalyses';

const appReducer = combineReducers({
  app,
  appointmentFlows,
  appointmentAnalyses,
  blobs,
  bookFlows,
  bookAnalyses,
  confirmFlows,
  confirmAnalyses,
  confirmations,
  conversations,
  waterfallAnalyses,
  waterfallFlows,
  error,
  esignFlows,
  esignAnalyses,
  esignTemplates,
  events,
  fifthFlows,
  fifthAnalyses,
  fillFlows,
  fillAnalyses,
  fillTemplates,
  firstFlows,
  firstAnalyses,
  invitations,
  locations,
  managers,
  messages,
  nylas,
  patientFlows,
  patientAnalyses,
  patients,
  penStudyFlows,
  penStudyAnalyses,
  profile,
  referralFlows,
  referralAnalyses,
  reminderFlows,
  reminderAnalyses,
  scheduleFlows,
  scheduleAnalyses,
  clinicians,
  secondFlows,
  secondAnalyses,
  session,
  sessions,
  seventhFlows,
  seventhAnalyses,
  sixthFlows,
  sixthAnalyses,
  studyFlows,
  studyAnalyses,
  studyTasks,
  success,
  superbillAnalyses,
  superbillFlows,
  superbillGoals,
  superbillTasks,
  templates,
  thirdAnalyses,
  thirdFlows,
  voiceFlows,
  voiceAnalyses
});

export const clearStore = () => ({
  type: 'CLEAR_STORE',
});

const reducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {

    return appReducer(undefined, action);
  }

  return appReducer(state, action);
}

const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(errorMiddleware)
});

export default store;
